import React, { useState } from 'react';
import MaximizedDialog from '../panels/expandable/MaximizedDialog';
import GridPanelHeader from '../panels/expandable/GridPanelHeader';
import { Panel } from 'primereact/panel';
import styled from 'styled-components';

type Props = {
  title: string;
  children?: React.ReactNode;
  hideMaximizeButton?: boolean;
  expandedModeOnly?: boolean;
  maximizableContent?: React.ReactNode;
  additionalContent?: React.ReactNode;
};

const VersionHistoryExpandableGridWrapper: React.FC<Props> = ({
  title,
  children,
  hideMaximizeButton,
  expandedModeOnly,
  maximizableContent,
  additionalContent,
}) => {
  const [visible, setVisible] = useState(false);
  const onMaximize = () => {
    setVisible(true);
  };

  return (
    <>
      <MaximizedDialog title={title} onHide={() => setVisible(false)} visible={visible}>
        {maximizableContent || children}
      </MaximizedDialog>

      <PaddinglessPanel
        headerTemplate={(options) => (
          <GridPanelHeader
            options={options}
            title={title}
            onMaximize={onMaximize}
            hideMaximizeButton={hideMaximizeButton}
            hideToggleButton={expandedModeOnly}
          />
        )}
        toggleable={!expandedModeOnly}
        collapsed={!expandedModeOnly}
      >
        {children ? (
          <div style={{ overflowX: 'hidden' }}>{children}</div>
        ) : (
          <div style={{ display: 'grid', gap: '30px' }}>
            <div style={{ overflowX: 'hidden' }}>{maximizableContent}</div>
            <div style={{ overflowX: 'hidden' }}>{additionalContent}</div>
          </div>
        )}
      </PaddinglessPanel>
    </>
  );
};

export default VersionHistoryExpandableGridWrapper;

const PaddinglessPanel = styled(Panel)`
  && .p-panel-header {
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
    background-color: transparent;
    border: none;
  }
  && .p-panel-content {
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
    background-color: transparent;
    display: grid;
  }
`;
